import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi } from '@fortawesome/free-solid-svg-icons';


const OfflineNotification = props => {

    const [isOnline, setIsOnline] = useState(true);

    useEffect(() => {
        setIsOnline(navigator.onLine);
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    const handleOnline = () => {
        setIsOnline(true);
        window.location.reload(true);
    };

    const handleOffline = () => {
        setIsOnline(false);
    };

    return !isOnline ? (
        <div className="floating-notification">
            <FontAwesomeIcon icon={faWifi} className="fa-icon" />
            <FormattedMessage id="WARNING_INTERNET_OFFLINE" />
            <span className="btn-close-notification" onClick={() => setIsOnline(true)}>
                &times;
            </span>
        </div>
    ) : null;
};

export default OfflineNotification;
